import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router/composables'
import { bannerEligible, useBannerShow } from './useBannerShow'
import { brand, brandConfig } from '@/config/brands'
import { createBannerSession, isTopBannerRoute } from '@/utils/appBannerPolicy'

// 延迟读取 storage，兼容浏览器禁用存储时 getter 本身抛错。
const session = createBannerSession({
  getItem: key => window.sessionStorage.getItem(key),
  setItem: (key, value) => window.sessionStorage.setItem(key, value),
}, brand)
const dismissed = ref(session.isDismissed())

export function useTopAppBanner() {
  const route = useRoute()
  const config = brandConfig.appBanner?.topBanner
  const eligibleRoute = computed(() => isTopBannerRoute(config, route.name, route.query.from))
  watch(eligibleRoute, (eligible) => {
    if (eligible && !dismissed.value)
      useBannerShow()
  }, { immediate: true })
  const visible = computed(() => eligibleRoute.value && bannerEligible.value && !dismissed.value)
  function close() {
    session.dismiss()
    dismissed.value = true
  }
  return { visible, close }
}
